import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Modal from "../../../../utils/customModal";
import { getSpk } from "../../../../../Redux/reducer/env";
import StepControl from "../../register/steps/stepControl";
import * as instanceActions from "../../../../../Redux/api";
import { encryptPassword } from "../../../../utils/functions";
import {
  loadingHtml,
  errorContainer,
  infoContainer,
} from "../../../../utils/functions";

import LockIcon from "../../../../../../static/images/lock-icon.svg";
import CloseIcon from "../../../../../../static/images/close-icon.svg";
import ShowIcon from "../../../../../../static/images/show-icon.svg";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";

export class ResetStep5 extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      user: {
        username: "",
        userpasswrd: "",
        confirm_userpasswrd: "",
        hideUserpass: true,
        hideConsPass: true,
        temporal: "",
      },
      modal: {
        show: false,
        content: null,
        onClose: undefined,
      },
      errors: {
        username: "",
        userpasswrd: "",
        confirm_userpasswrd: "",
        temporal: "",
      },
    };
  }

  handlerChange(event) {
    // Limpiamos los errores
    const { user, errors } = this.state;
    errors[event.target.name] = "";
    user[event.target.name] = event.target.value;

    this.setState({ user, errors });
  }

  clear(event, element) {
    event.preventDefault();
    const user = this.state.user;
    user[element] = "";

    // Estamos limpiando la contraseña
    if (element.indexOf("userpasswrd") != -1) {
      switch (element) {
        case "userpasswrd":
          user.hideUserpass = true;
          break;
        case "confirm_userpasswrd":
          user.hideConsPass = true;
          break;
      }
    }

    this.setState({ user });
  }

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.content = null;
    modal.onClose = undefined;
    this.setState({ modal });
  };

  closeButton(element) {
    return this.state.user[element] != "" ? (
      <div
        key={`clear-${element}`}
        className="button-auto input-w-aux__action clear-user"
        onClick={(event) => this.clear(event, element)}
      >
        <img src={CloseIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  showInput(event, element) {
    event.preventDefault();
    const { user } = this.state;

    switch (element) {
      case "userpasswrd":
        user.hideUserpass = !user.hideUserpass;
        this.setState({ user });
        break;
      case "confirm_userpasswrd":
        user.hideConsPass = !user.hideConsPass;
        this.setState({ user });
        break;
    }
  }

  showPass(element) {
    return this.state.user[element] != "" ? (
      <div
        className="button-auto input-w-aux__action show-password fix-show-button"
        onClick={(event) => this.showInput(event, element)}
      >
        <img src={ShowIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  nextStep = () => {
    const { history } = this.props;
    history.push("/landing");
  };

  finalStep = () => {
    var buttons = {
      SelBtn: {
        text: "Aceptar",
        action: this.nextStep,
      },
    };

    var content = infoContainer(
      "Contraseña actualizada con éxito",
      `Su contraseña ha sido actualizada con éxito`,
      buttons
    );
    this.setState({ modal: { content, show: true } });
  };

  submitForm(e) {
    e.preventDefault();
    const { user, errors } = this.state;

    // validamos campos vacios
    if (
      user.temporal != "" &&
      user.userpasswrd != "" &&
      user.confirm_userpasswrd != ""
    ) {
      errors.temporal = "";
      errors.userpasswrd = "";
      errors.confirm_userpasswrd = "";
      this.setState({ errors });
      if (this.validatePassword()) {
        //si todo va bien vamos al paso 2
        const { user, modal } = this.state;
        const {
          instance: { instanceAction },
        } = this.props;

        const data = {
          codUser: encryptPassword(this.props.user.codUser, this.props.spk),
          temporaryPassword: encryptPassword(user.temporal, this.props.spk),
          newPassword: encryptPassword(user.userpasswrd, this.props.spk),
          newPasswordConfirmation: encryptPassword(
            this.state.user.confirm_userpasswrd,
            this.props.spk
          ),
        };

        modal.show = true;
        modal.content = loadingHtml();
        this.setState({ modal });
        return instanceAction(`/password-recovery/change-password`, "put", data)
          .then(() => {
            this.finalStep();
          })
          .catch((err) => {
            if (
              err.response !== undefined &&
              Array.isArray(err.response.data.notifications)
            ) {
              const notification = err.response.data.notifications[0];
              modal.content = errorContainer(
                notification.message,
                notification.description
              );
            }
            modal.onClose = () => this.closeModal();
            this.setState({ modal });
          });
      }
    } else {
      if (user.temporal == "") {
        errors.temporal = "Debe completar este campo";
      }
      if (user.username == "") {
        errors.username = "Debe completar este campo";
      }
      if (user.confirm_userpasswrd == "") {
        errors.confirm_userpasswrd = "Debe completar este campo";
      }
      this.setState({ errors });
    }
  }

  validatePassword() {
    const { user, errors } = this.state;
    var regexp = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/);
    var regexTemp = new RegExp(/^(?=.*\d)(?=.*[A-Z]).{8,}$$/);
    var result = regexp.test(user.userpasswrd);
    var tempResult = regexTemp.test(user.temporal);
    if (result) {
      if (tempResult) {
        if (user.userpasswrd != this.props.user.codUser) {
          if (user.userpasswrd == user.confirm_userpasswrd) {
            // Contraseña válida
            errors.userpasswrd = "";
            this.setState({ errors });
            return true;
          } else {
            errors.userpasswrd = "Las contraseñas no coinciden";
            this.setState({ errors });
            this.inputErrors("userpasswrd", true);

            return false;
          }
        } else {
          //Nombre de usuario y contraseña no deben coincidir
          errors.userpasswrd =
            "El nombre de usuario y contraseña no deben coincidir";
          this.setState({ errors });
          this.inputErrors("userpasswrd");

          return false;
        }
      } else {
        // La contraseña no coincide con el patrón
        errors.temporal = "La contraseña temporal no coincide con el patron";
        this.setState({ errors });

        this.inputErrors("temporal", true);

        return false;
      }
    } else {
      // La contraseña no coincide con el patrón
      errors.userpasswrd = "La contraseña no coincide con el patron";
      this.setState({ errors });

      this.inputErrors("userpasswrd", true);

      return false;
    }
  }

  inputErrors(id, hasFocus = false) {
    document.getElementById(id).classList.add("input--error");
    if (hasFocus) {
      document.getElementById(id).focus();
    }
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    const { modal } = this.state;
    return (
      <div id="step-1">
        <div className="user-credentials">
          <h1>Cambiar contraseña</h1>
          <div className="login-form">
            <form
              className="login"
              action="post"
              onSubmit={(e) => this.submitForm(e)}
            >
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Confirmar contraseña`}
                />
                <input
                  id="temporal"
                  name="temporal"
                  className="input input--text input-w-aux__input input--active"
                  type="text"
                  placeholder={`Digite la contraseña provisional`}
                  autoComplete="off"
                  value={this.state.user.temporal}
                  onChange={(event) => this.handlerChange(event)}
                />
                {this.closeButton("temporal")}
                {this.displayError("temporal")}
              </div>
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Contraseña`}
                />
                <input
                  id="userpasswrd"
                  name="userpasswrd"
                  className="input input--text input-w-aux__input input--active"
                  type={this.state.user.hideUserpass ? "password" : "text"}
                  placeholder={`Digite su nueva contraseña`}
                  autoComplete="off"
                  value={this.state.user.userpasswrd}
                  onChange={(event) => this.handlerChange(event)}
                  data-tip
                  data-for="password-disclaimer"
                />
                {this.closeButton("userpasswrd")}
                {this.showPass("userpasswrd")}
                <ReactTooltip
                  id="password-disclaimer"
                  className="info-tooltip"
                  type="light"
                  effect="solid"
                  place="right"
                  offset={{ top: 0 }}
                  event="focus"
                  eventOff="focusout"
                >
                  <div className="tooltip-content">
                    <p>La contraseña debe tener la siguiente estructura:</p>
                    <ul>
                      <li>8 o más caracteres de extensión</li>
                      <li>Se requiere al menos una letra minúscula</li>
                      <li>Se requiere al menos una letra mayúscula</li>
                      <li>Se requiere al menos un número</li>
                      <li>No debe contener su nombre de usuario</li>
                      <li>No se permiten caracteres especiales (ej: !$%&)</li>
                    </ul>
                  </div>
                </ReactTooltip>
                {this.displayError("userpasswrd")}
              </div>
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Confirmar contraseña`}
                />
                <input
                  id="confirm_userpasswrd"
                  name="confirm_userpasswrd"
                  className="input input--text input-w-aux__input input--active"
                  type={this.state.user.hideConsPass ? "password" : "text"}
                  placeholder={`Confirmar contraseña`}
                  autoComplete="off"
                  value={this.state.user.confirm_userpasswrd}
                  onChange={(event) => this.handlerChange(event)}
                />
                {this.closeButton("confirm_userpasswrd")}
                {this.showPass("confirm_userpasswrd")}
                {this.displayError("confirm_userpasswrd")}
              </div>
              <StepControl
                currentStep={1}
                submitStep={(e) => this.submitForm(e)}
              />
            </form>
          </div>
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          handleClose={modal.onClose}
        >
          {modal.content}
        </Modal>
      </div>
    );
  }
}

ResetStep5.propTypes = {
  user: PropTypes.object.isRequired,
  submitStep: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    registerInfo: state.sessionInfoReducer.registerInfo,
    spk: getSpk(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatch)(ResetStep5));
